import { render } from "./PlanoEdit.vue?vue&type=template&id=00418a2c"
import script from "./PlanoEdit.vue?vue&type=script&lang=js"
export * from "./PlanoEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__